import CollapsibleSelect from './CollapsibleSelect';

export default CollapsibleSelect;
